import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import styled from "@emotion/styled";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import { Box, ListItem } from "@mui/material";
import Accordion from "@mui/material/Accordion";

export const StyledTextField = styled(TextField)({
  backgroundColor: "#F0F0F0",
  borderRadius: 15,
  boxShadow: "none",
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "transparent",
      borderRadius: 15,
    },
    "&:hover fieldset": {
      borderColor: "#1EABF1",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1EABF1",
    },
  },
});

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "myColor" && prop !== "hoverColor",
})(({ theme, myColor, hoverColor }) => ({
  color: "#ffffff",
  textTransform: "none",
  backgroundColor: myColor,
  height: "45px",
  minWidth: "160px",
  fontFamily: "Source Sans Pro SemiBold",
  padding: "0 15px",
  fontSize: "0.875rem",
  boxShadow: "none",
  borderRadius: 13,
  "&:hover": {
    backgroundColor: hoverColor,
    boxShadow: "none",
  },
  "@media (max-width: 960px)": {
    minWidth: "140px",
    height: "35px",
    fontSize: "0.75rem",
  },
  "@media (max-width: 600px)": {
    minWidth: "120px",
    height: "30px",
    fontSize: "0.625rem",
  },
}));

export const StyledIconButton = styled(IconButton)({
  textTransform: "none",
  //color: '#B2B2B2',
  color: "#20242A",
  boxShadow: "none",
  borderRadius: 13,
  "&:hover": {
    color: "#C46A2D",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
});

export const StyledLink = styled(Link)({
  textTransform: "none",
  //color: '#B2B2B2',
  color: "#57606f",
  boxShadow: "none",
  borderRadius: 13,
  "&:hover": {
    color: "#5FC9F8",
    boxShadow: "none",
  },
});

export const StyledSelect = styled(Select)({
  backgroundColor: "#F0F0F0",
  borderRadius: 15,
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#1EABF1",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#1EABF1",
  },
});

export const CenteredListItem = styled(ListItem)({
  display: "flex",
  justifyContent: "center",
  width: "100%",
});

export const SegmentedControlContainer = styled(Box)({
  backgroundColor: "rgba(49, 54, 63, 0.8)",
  backdropFilter: "saturate(200%) blur(30px)",
  borderRadius: "15px",
  "@media (max-width: 900px)": {
    backgroundColor: "rgba(49, 54, 63, 0.95)",
    backdropFilter: "none",
  },
});

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: theme.spacing(4), // Adds margin-bottom for spacing between accordions
  padding: "5px",
  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.10)",
  borderRadius: "20px",
  backdropFilter: "blur(4px)",
  fontFamily: "Source Sans Pro Bold",
  color: "#f5f5f5", // Sets text color
  backgroundColor: "#222831",
  "&:not(:last-of-type)": {
    borderBottom: "none", // Remove bottom border of non-last accordions
  },
  "&:before": {
    display: "none", // Removes the default divider line between accordions
  },
}));
